import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import AuthService from '../../../Services/authService';

export default class LeadSearchParams extends SearchParamsBase {
  initialize() {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();

    this.LeadId = ''; //User can search for ProjectName with this field too.
    this.CompanyName = '';
    this.Email = '';
    this.SelectedOfficeIds = []; //loggedInUser===undefined?[]:[loggedInUser.officeId];
    this.UserId = loggedInUser === undefined ? 0 : loggedInUser.userId;
    this.Converted = '';
    this.IsActive = 'true';
    this.IsImported = '';
    this.SelectedIndustries = [];
    this.SelectedStatuses = [];
    this.SelectedSources = [];
    this.SelectedMsPartners = [];
    this.SelectedCountries = [];
    this.ContactName = '';
    this.AllowBulkEmail = '';
    this.AllowEmail = '';
    this.AllowPhone = '';
    this.AllowPostMail = '';
    this.AllowSocialMedia = '';
    this.UseCreatedOnDateRange = false;
    this.CreatedOnOrAfter = dateTimeHelper.indefiniteDateValue();
    this.CreatedOnOrBefore = dateTimeHelper.indefiniteDateValue();
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.EndDate = dateTimeHelper.lastDayOfTheActualMonth();
  }

  static fieldsInSearchBox = [
    { fieldName: 'LeadId', label: 'Lead Id', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CompanyName', label: 'Company Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'UserId', label: 'Assigned to', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'Email', label: 'Email', className: 'col-4', type: InputTypesEnum.Email },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'Converted', label: 'Converted', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsImported', label: 'Is Imported', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'ContactName', label: 'Contact Name', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedIndustries',
      label: 'Industry',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 6,
    },
    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 5,
    },
    {
      fieldName: 'SelectedSources',
      label: 'Source',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 7,
    },
    {
      fieldName: 'SelectedMsPartners',
      label: 'MSPartner',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 83,
    },
    { fieldName: 'SelectedCountries', label: 'Country', className: 'col-4', type: InputTypesEnum.CountryMultiChoice },
    {
      fieldName: 'AllowBulkEmail',
      label: 'Allow Bulk Email',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    { fieldName: 'AllowEmail', label: 'Allow Email', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'AllowPhone', label: 'Allow Phone', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'AllowPostMail', label: 'Allow Post Mail', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'AllowSocialMedia',
      label: 'Allow Social Media',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    { fieldName: 'UseDateRange', label: 'Use Callback Date Range', className: 'col-4', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-2',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-2',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'UseCreatedOnDateRange',
      label: 'Use Created On Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CreatedOnOrAfter',
      label: 'Created On Or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'CreatedOnOrBefore',
      label: 'Created On Or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'LeadSearchParams';
}
